/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Config')
    .factory('HttpErrorInterceptor', ['$q', 'flashMessagesService',
        function ($q, flashMessagesService) {
            return {
                'responseError': function (response) {
                    var rejection = $q.reject(response);

                    if (response.config.ignoreApiErrors) return rejection;
                    if (response.status === 0) return rejection; // 0 is canceled
                    if (response.config.ignoreConflictErrors && response.status === 409) return rejection;

                    if (response.data && response.data.error.message) {
                        flashMessagesService.add(response.data.error.message, flashMessagesService.ERROR);
                    }

                    return rejection;
                }
            }
        }]);
